import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { Button } from '../components/ui/button';
import { ArrowRight } from 'lucide-react';
import SEO from '../components/SEO';

export default function NotFoundPage() {
  const { t, lp } = useLanguage();

  return (
    <section className="min-h-[70vh] flex items-center blueprint-bg" data-testid="not-found-page">
      <SEO />
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-24">
        <p className="font-mono text-[#066ce7] text-sm mb-4">404</p>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-[#0F172A] mb-6" data-testid="not-found-title">{t('notfound.title')}</h1>
        <p className="text-slate-600 text-lg max-w-xl mb-10">{t('notfound.text')}</p>
        <div className="flex flex-wrap gap-4">
          <Link to={lp('/')}>
            <Button className="bg-[#066ce7] hover:bg-[#005bb5] text-white px-6" data-testid="not-found-home-btn">
              {t('notfound.home')} <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </Link>
          <Link to={lp('/leistungen')}>
            <Button variant="outline" className="px-6" data-testid="not-found-services-btn">{t('nav.allServices')}</Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
